import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { getAssetPath } from "@commonUtils"

import css from "./QuantitySelector.scss"

function QuantitySelector(props) {
    const [count, setCount] = useState(0)
    const [displayCount, setDisplayCount] = useState(0)
    const [isUpdating, setIsUpdating] = useState(false)
    const [minRange, setMinRange] = useState(1)
    const [maxRange, setMaxRange] = useState(9999)

    useEffect(() => {
        if (props.minRange) {
            setMinRange(props.minRange)
        }
        if (props.maxRange) {
            setMaxRange(props.maxRange)
        }
    }, [props.minRange, props.maxRange])

    useEffect(() => {
        //   if the local count is being updated set isUpdating state to true which will show the loader. When the count is updated in the backend and we get the props.value same as count set isUpdating state to false and update the displayCount.
        if (count === props.value) {
            setDisplayCount(count)
            setIsUpdating(false)
        } else {
            setIsUpdating(true)
        }
    }, [count, props.value])

    useEffect(() => {
        // if the API call has failed set the isUpdating state to false and reset the local count to the count stored in the reducer.
        if (!props.isUpdating) {
            setIsUpdating(props.isUpdating)
            setCount(props.value)
        }
    }, [props.isUpdating, props.value])

    const handleIncrement = () => {
        // increment the count if it is less than maxrange
        if (!props.isDisabled && count < maxRange && typeof props.onChange === "function") {
            setCount((count) => count + 1)
            props.onChange(count + 1)
        }
    }

    const handleDecrement = () => {
        // decrement the count if it is more than minRange. If count is equal to the minRange deleteAction will be performed.
        if (!props.isDisabled && count > minRange && typeof props.onChange === "function") {
            setCount((count) => count - 1)
            props.onChange(count - 1)
        }
    }

    const handleDelete = () => {
        props.onDelete()
    }

    return (
        <div
            className={`flex alignCenter textCenter justifyBetween ${css.quantitySelector} ${
                props.isDisabled ? css.disabledSelector : ""
            }`}
        >
            {/* show delete button if count is equal to props.minRange else show decrement button */}
            {displayCount === props.minRange ? (
                <button
                    className={`gutter-only flex alignCenter ${css.icon}`}
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleDelete()
                    }}
                >
                    <img
                        src={getAssetPath("svgs/icons/delete_18px_primary.svg")}
                        alt="delete item"
                        width={24}
                        height={24}
                    />
                </button>
            ) : (
                <button
                    className={`gutter-only flex alignCenter ${css.icon}`}
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleDecrement()
                    }}
                >
                    <img
                        src={getAssetPath("svgs/icons/minus_primary.svg")}
                        alt="reduce quantity"
                        width={24}
                        height={24}
                    />
                </button>
            )}
            {/* show the loader while the count is being updated else show the count*/}
            {isUpdating || props.isDeleting || props.value !== count ? (
                <div className="marginTop-4">
                    <img
                        src={getAssetPath("svgs/icons/loading-wheel_24px_action.svg")}
                        width={24}
                        height={24}
                        alt="loader"
                    />
                </div>
            ) : (
                <div className={`l5Medium ${css.countHeightWidth}`}>{displayCount}</div>
            )}

            {/* disable increment button if the count is greater than or equal to props.maxRange */}
            <button
                disabled={props.isDisabled || count >= props.maxRange}
                className={`gutter-only flex alignCenter ${css.icon}`}
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    handleIncrement()
                }}
            >
                <img
                    src={getAssetPath(
                        props.isDisabled || count < props.maxRange
                            ? "svgs/icons/plus_primary.svg"
                            : "svgs/icons/plus_disabled.svg"
                    )}
                    alt="add quantity"
                    width={24}
                    height={24}
                />
            </button>
        </div>
    )
}

QuantitySelector.propTypes = {
    value: PropTypes.number,
    minRange: PropTypes.number,
    maxRange: PropTypes.number,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    onDelete: PropTypes.func,
    isDeleting: PropTypes.bool,
    isUpdating: PropTypes.bool,
}

export default QuantitySelector
